const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/_user/profile/edit/leadership.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { defineMessage } from "react-intl";
import { z } from "zod";
export const Route = createFileRoute("/_authenticated/_feature_announcement/_user/profile/edit/leadership")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(z.object({
    from: z.iso.date().optional(),
    to: z.iso.date().optional(),
    networks: z.array(z.string()).optional()
  })),
  staticData: {
    pageTitle: defineMessage({
      defaultMessage: "Leadership Impact",
      description: "Page title for the leadership impact report settings path"
    })
  }
});